export default __webpack_public_path__ + "static/media/kahshPayVideo.b526fa89.png";